export default __webpack_public_path__ + "204f793cb0608261c6638d22cd4cf769.jpg";